import { Suspense } from "react";
import { InfoSection } from "../sections/info-section";
import { useModuleContext } from "src/lib/context/module-context";
import { modules } from "src/lib/constants/modules";
import { useTranslation } from "react-i18next";
import { InfoSectionWithSteps } from "../sections/info-section-with-steps";
import { useTheme } from "src/lib/context/theme-context";
import "./styles.css";

export const ModuleRenderer = () => {
  const { t } = useTranslation(["common", "module1", "module2", "module3", "module4"]);
  const { currentModuleNumber, currentStep } = useModuleContext();
  const theme = useTheme();

  // Variables
  const currentModule = modules[currentModuleNumber - 1];
  const currentScreen = currentModule.steps[currentStep - 1];

  const getImage = (screen) => {
    if (theme === "dark" && screen.darkImage) {
      return screen.darkImage;
    }
    return screen.image;
  };

  return (
    <Suspense fallback={<div className="loading-skeleton" />}>
      {currentScreen?.type === "info" ? (
        <InfoSection
          image={getImage(currentScreen)}
          title={t(currentScreen.title)}
          heading={t(currentScreen?.heading)}
          description={t(currentScreen.description)}
          subSections={currentScreen.subSections}
        />
      ) : currentScreen?.type === "info_with_steps" ? (
        <InfoSectionWithSteps
          steps={currentScreen.steps}
          title={t(currentScreen.title)}
        />
      ) : null}
    </Suspense>
  );
};
